import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Mail, Lock, AlertCircle } from 'lucide-react'
import Button from '../ui/Button'
import Input from '../ui/Input'
import { useAuth } from '../../context/AuthContext'

const LoginForm = ({ onSwitchToSignup }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [error, setError] = useState('')
  const { signIn, loading } = useAuth()
  const navigate = useNavigate()

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (!formData.email || !formData.password) {
      setError('请填写所有必填字段')
      return
    }

    try {
      await signIn(formData.email, formData.password)
      // 登录成功后跳转到首页
      navigate('/dashboard')
    } catch (error) {
      setError(error.message || '登录失败，请检查邮箱和密码')
    }
  }

  return (
    <div className="max-w-md mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-900">登录账户</h2>
        <p className="mt-2 text-gray-600">
          还没有账户？{' '}
          <button
            onClick={onSwitchToSignup}
            className="text-primary-600 hover:text-primary-500 font-medium"
          >
            立即注册
          </button>
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <div className="flex items-center">
              <AlertCircle className="h-5 w-5 text-red-400 mr-2" />
              <span className="text-red-700 text-sm">{error}</span>
            </div>
          </div>
        )}

        <div>
          <Input
            label="邮箱地址"
            type="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            placeholder="请输入邮箱地址"
          />
        </div>

        <div>
          <Input
            label="密码"
            type="password"
            name="password"
            required
            value={formData.password}
            onChange={handleChange}
            placeholder="请输入密码"
          />
        </div>

        <Button
          type="submit"
          loading={loading}
          className="w-full"
        >
          登录
        </Button>
      </form>
    </div>
  )
}

export default LoginForm